<div class="flex flex-col h-full">
  <div>
    <h1>Jobopslag</h1>
  </div>
  <p-tabs
    [(value)]="jobopslagService.activeTab"
    class="flex-1 border-1 overflow-hidden">
    <p-tablist>
      <p-tab value="list"><i class="pi pi-list"></i> Liste</p-tab>
      @if (
        jobopslagService.selectedJobopslag() ||
        jobopslagService.mode() === 'create'
      ) {
        <p-tab value="detail"><i class="pi pi-file"></i> Detaljer</p-tab>
      }
      @if (jobopslagService.activeTab() !== 'detail') {
        <div class="mt-2 ml-8">
          <p-button
            icon="pi pi-plus"
            outlined
            label="Opret jobopslag"
            (click)="jobopslagService.opretJobopslag()"></p-button>
        </div>
      }
    </p-tablist>
    <p-tabpanels class="overflow-hidden">
      <p-tabpanel value="list">
        <app-letpensiondk-jobopslag-list />
      </p-tabpanel>
      <p-tabpanel value="detail">
        <app-letpensiondk-jobopslag-detail />
      </p-tabpanel>
    </p-tabpanels>
  </p-tabs>
</div>
